import { AxiosError, AxiosInstance } from 'axios'

import { Account } from '@driftt/api-types'
import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Account API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const AccountAPI: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.ACCOUNTS_API
  }
})
export const getAccountById = (accountId: string) =>
  AccountAPI.get<Account>(`/accounts/${accountId}`).then(res => res.data)

export const fetchAttributes = async () => {
  return AccountAPI.get('/attrib').then(res => res.data)
}

export const findAccount = (orgId: number, domain: string) => {
  return AccountAPI.get(
    `/accounts/findAccount?orgId=${encodeURIComponent(orgId)}&domain=${encodeURIComponent(domain)}`
  )
    .then(res => res.data)
    .catch(err => {
      if (err.response.status === 404) {
        return {}
      }
      throw err
    })
}
